import React from "react";
import JobsContainer from "../../containers/jobs/index";
import JobContainer from "../../containers/jobs/Job";
import { useParams } from "react-router-dom";

const JobsPage = () => {
  let { id } = useParams();

  return id ? <JobContainer id={id} /> : <JobsContainer />;
};

export default JobsPage;
